/*
 * VALUAN — widget de bundles (substitui o Kaching).
 *
 * O mesmo arquivo roda em dois lugares:
 *   - na loja (assets/vt-bundle.js), preso ao formulário de compra do Impact;
 *   - no painel bundles-valuan, só para a pré-visualização.
 *
 * A configuração vem pronta do painel (metafield shop.vt_bundles.vitrine) e o
 * desconto é um desconto automático nativo da Shopify. Este arquivo só mostra
 * a oferta e coloca os itens certos no carrinho — nunca calcula o desconto
 * que vale de verdade, só o que mostra na tela.
 */
(function () {
  'use strict';

  if (window.VTBundle && window.VTBundle.montar) return;

  var PROPRIEDADE = '_vt_bundle';

  /* ------------------------------------------------------------------ util */

  function texto(valor, locale) {
    if (valor == null) return '';
    if (typeof valor === 'string') return valor;
    if (valor[locale]) return valor[locale];
    if (valor.en) return valor.en;
    for (var k in valor) if (valor[k]) return valor[k];
    return '';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function preencher(modelo, vars) {
    return String(modelo || '').replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, function (m, nome) {
      return Object.prototype.hasOwnProperty.call(vars, nome) ? vars[nome] : m;
    });
  }

  /*
   * Formatador de dinheiro a partir de uma amostra que o Liquid gera com o
   * filtro money (123456 centavos). Assim a vitrine usa exatamente o formato
   * do mercado do visitante: "€1.234,56", "$1,234.56", "¥1,235"...
   */
  function formatadorPorAmostra(amostra) {
    amostra = String(amostra || '');
    var m = amostra.match(/\d[\d.,'\s  ]*\d|\d/);
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var num = m[0];
    var antes = amostra.slice(0, m.index);
    var depois = amostra.slice(m.index + num.length);
    var dec = null, mil = '';
    var ult = num.match(/[.,](\d+)$/);
    if (ult && ult[1].length === 2) {
      dec = num.charAt(num.length - 3);
      var resto = num.slice(0, -3);
      var sep = resto.match(/[^\d]/);
      mil = sep ? sep[0] : '';
    } else {
      var s2 = num.match(/[^\d]/);
      mil = s2 ? s2[0] : '';
    }
    return function (centavos, semCentavos) {
      var usarDec = dec && !semCentavos;
      var v = usarDec ? (centavos / 100).toFixed(2) : String(Math.round(centavos / 100));
      var partes = v.split('.');
      var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
      return antes + inteiro + (usarDec ? dec + partes[1] : '') + depois;
    };
  }

  /* ---------------------------------------------------------------- preços */

  function totalUnidades(barra) {
    return Math.max(1, (barra.compre | 0) + (barra.ganhe | 0));
  }

  /*
   * Espelha o desconto nativo que o painel cria para a barra:
   *   - compre X ganhe Y: Shopify tira o desconto dos itens MAIS BARATOS;
   *   - quantidade com %: desconto sobre todos os itens.
   */
  function ehMix(barra) {
    return barra && barra.tipo === 'mix';
  }

  function calcular(barra, variantes, opcoes, brindes) {
    var cheioDe = function (v) {
      if (!v) return 0;
      if (opcoes.usarComparativo && v.compare_at_price && v.compare_at_price > v.price) return v.compare_at_price;
      return v.price;
    };
    var soma = function (l, fn) { return l.reduce(function (a, v) { return a + fn(v); }, 0); };
    var preco = function (v) { return v ? v.price : 0; };
    var precos = variantes.map(preco);
    var total = soma(variantes, preco);
    var cheio = soma(variantes, cheioDe);
    var desconto = 0;
    if (ehMix(barra)) {
      // mix & match: o desconto sai só dos brindes (outro produto)
      var lista = brindes || [];
      var pctB = barra.descontoGanhe == null ? 100 : Number(barra.descontoGanhe);
      total += soma(lista, preco);
      cheio += soma(lista, cheioDe);
      lista.forEach(function (v) { desconto += Math.round(preco(v) * pctB / 100); });
      var finalM = total - desconto;
      return { final: finalM, cheio: Math.max(cheio, total), economia: Math.max(cheio, total) - finalM, unidades: variantes.length + lista.length };
    }
    if ((barra.ganhe | 0) > 0) {
      var pct = barra.descontoGanhe == null ? 100 : Number(barra.descontoGanhe);
      var ordenados = precos.slice().sort(function (a, b) { return a - b; });
      for (var i = 0; i < (barra.ganhe | 0) && i < ordenados.length; i++) {
        desconto += Math.round(ordenados[i] * pct / 100);
      }
    } else if (Number(barra.descontoCompre) > 0) {
      desconto = Math.round(total * Number(barra.descontoCompre) / 100);
    }
    var final = total - desconto;
    return {
      final: final,
      cheio: Math.max(cheio, total),
      economia: Math.max(cheio, total) - final,
      unidades: variantes.length
    };
  }

  /* -------------------------------------------------------------- estilo */

  var ESTILO_PADRAO = {
    layout: 'empilhado',
    raio: 0,
    espacamento: 12,
    borda: 2,
    cores: {
      fundo: '#ffffff', fundoSel: '#ffffff', borda: '#d4d4d4', bordaSel: '#111111',
      tituloBloco: '#111111', linhaTitulo: '#bdbdbd',
      titulo: '#111111', subtitulo: '#555555', preco: '#111111', precoCheio: '#555555',
      etiquetaFundo: '#e8e8e8', etiquetaTexto: '#111111',
      seloFundo: '#111111', seloTexto: '#ffffff',
      radio: '#111111', rotulo: '#111111', seletorBorda: '#bdbdbd',
      presenteFundo: '#f5f5f0', presenteBorda: '#111111', presenteTexto: '#111111',
      presenteTagFundo: '#111111', presenteTagTexto: '#ffffff'
    },
    fonte: {
      familia: '',
      tituloBloco: { tam: 14, peso: 700 },
      titulo: { tam: 20, peso: 600 },
      subtitulo: { tam: 14, peso: 400 },
      preco: { tam: 20, peso: 700 },
      etiqueta: { tam: 12, peso: 500 },
      selo: { tam: 13, peso: 700 },
      rotulo: { tam: 14, peso: 600 }
    },
    css: ''
  };

  function mesclar(base, extra) {
    if (!extra || typeof extra !== 'object') return base;
    var out = Array.isArray(base) ? base.slice() : {};
    for (var k in base) out[k] = base[k];
    for (var j in extra) {
      if (extra[j] && typeof extra[j] === 'object' && !Array.isArray(extra[j]) && base[j] && typeof base[j] === 'object') {
        out[j] = mesclar(base[j], extra[j]);
      } else if (extra[j] !== undefined && extra[j] !== null && extra[j] !== '') {
        out[j] = extra[j];
      }
    }
    return out;
  }

  function variaveisCss(e) {
    var c = e.cores, f = e.fonte;
    var v = {
      '--vtb-raio': (Number(e.raio) || 0) + 'px',
      '--vtb-gap': (Number(e.espacamento) || 0) + 'px',
      '--vtb-borda': (Number(e.borda) || 1) + 'px',
      '--vtb-fundo': c.fundo, '--vtb-fundo-sel': c.fundoSel,
      '--vtb-cor-borda': c.borda, '--vtb-cor-borda-sel': c.bordaSel,
      '--vtb-cor-titulo-bloco': c.tituloBloco, '--vtb-cor-linha': c.linhaTitulo,
      '--vtb-cor-titulo': c.titulo, '--vtb-cor-sub': c.subtitulo,
      '--vtb-cor-preco': c.preco, '--vtb-cor-cheio': c.precoCheio,
      '--vtb-etiqueta-fundo': c.etiquetaFundo, '--vtb-etiqueta-texto': c.etiquetaTexto,
      '--vtb-selo-fundo': c.seloFundo, '--vtb-selo-texto': c.seloTexto,
      '--vtb-cor-radio': c.radio, '--vtb-cor-rotulo': c.rotulo, '--vtb-cor-seletor': c.seletorBorda,
      '--vtb-presente-fundo': c.presenteFundo, '--vtb-presente-borda': c.presenteBorda, '--vtb-presente-texto': c.presenteTexto,
      '--vtb-presente-tag-fundo': c.presenteTagFundo, '--vtb-presente-tag-texto': c.presenteTagTexto
    };
    ['tituloBloco', 'titulo', 'subtitulo', 'preco', 'etiqueta', 'selo', 'rotulo'].forEach(function (k) {
      v['--vtb-t-' + k] = (Number(f[k].tam) || 14) + 'px';
      v['--vtb-p-' + k] = String(f[k].peso || 400);
    });
    if (f.familia) v['--vtb-fonte'] = f.familia;
    var s = '';
    for (var k2 in v) s += k2 + ':' + v[k2] + ';';
    return s;
  }

  /* ------------------------------------------------------------- widget */

  /*
   * montar(elemento, {
   *   bundle, produto, locale, dinheiro (amostra) ou formatar (função),
   *   varianteInicial, form (HTMLFormElement, só na loja), previa (bool)
   * })
   */
  function montar(raiz, cfg) {
    var bundle = cfg.bundle;
    var produto = cfg.produto;
    var locale = cfg.locale || 'en';
    var opcoes = bundle.opcoes || {};
    var estilo = mesclar(ESTILO_PADRAO, bundle.estilo || {});
    var formatarBase = cfg.formatar || formatadorPorAmostra(cfg.dinheiro);
    var formatar = function (c) { return formatarBase(c, !!opcoes.semCentavos); };
    // produtos de brinde (mix & match), no mesmo formato do produto da página
    var brindePorProduto = {};
    (cfg.brindes || []).forEach(function (p) { if (p && p.variants && p.variants.length) brindePorProduto[String(p.id)] = p; });
    function numeroId(gid) { return String(gid || '').split('/').pop(); }
    function brindesDaBarra(b) {
      return (b.brindes || []).map(function (g) { return brindePorProduto[numeroId(g.id)]; }).filter(Boolean);
    }
    // barra mix sem nenhum brinde carregado (ex.: produto despublicado) não aparece
    var barras = (bundle.barras || []).filter(function (b) {
      return b && b.ativa !== false && (!ehMix(b) || ((b.ganhe | 0) > 0 && brindesDaBarra(b).length));
    });
    if (!barras.length || !produto || !produto.variants || !produto.variants.length) {
      raiz.innerHTML = '';
      return null;
    }

    var porId = {};
    produto.variants.forEach(function (v) { porId[String(v.id)] = v; });

    var inicial = porId[String(cfg.varianteInicial)] ||
      produto.variants.filter(function (v) { return v.available; })[0] || produto.variants[0];

    function porTitulo(t) {
      if (!t) return null;
      for (var i = 0; i < produto.variants.length; i++) {
        if (produto.variants[i].title === t) return produto.variants[i];
      }
      return null;
    }

    function unidadesPrincipais(b) {
      return ehMix(b) ? Math.max(1, b.compre | 0) : totalUnidades(b);
    }

    function primeiraDisponivel(p) {
      return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    }

    function varianteBrinde(id) {
      for (var k in brindePorProduto) {
        var p = brindePorProduto[k];
        for (var j = 0; j < p.variants.length; j++) if (String(p.variants[j].id) === String(id)) return { produto: p, variante: p.variants[j] };
      }
      return null;
    }

    // presentes: brinde extra do bundle (produto de €0), colado embaixo das barras
    var presentes = (bundle.presentes || []).filter(function (g) {
      return g && g.ativo !== false && g.produto && brindePorProduto[numeroId(g.produto.id)];
    });
    var escolhasPresente = presentes.map(function (g) {
      var p = brindePorProduto[numeroId(g.produto.id)];
      var padrao = null;
      if (g.variantePadrao) p.variants.forEach(function (v) { if (String(v.id) === String(g.variantePadrao)) padrao = v; });
      return padrao || primeiraDisponivel(p);
    });
    function presenteVale(g, barra) {
      if (!barra) return false;
      if (!g.barras || g.barras === 'todas') return true;
      return g.barras.indexOf(barra.id) >= 0;
    }

    // escolhasBrinde[i] = variantes de brinde (uma por unidade ganha) da barra i
    var escolhasBrinde = barras.map(function (b) {
      if (!ehMix(b)) return [];
      var lista = [];
      var dados = brindesDaBarra(b);
      var padrao = varianteBrinde(b.brindePadrao);
      for (var u = 0; u < (b.ganhe | 0); u++) {
        lista.push(padrao && padrao.variante ? padrao.variante : primeiraDisponivel(dados[0]));
      }
      return lista;
    });

    // escolhas[i] = lista de variantes (uma por unidade) da barra i
    var escolhas = barras.map(function (b) {
      var n = unidadesPrincipais(b);
      var lista = [];
      var padroes = b.variantesPadrao || [];
      // a primeira unidade é sempre a variante aberta na página
      for (var u = 0; u < n; u++) {
        lista.push(u === 0 ? inicial : (porTitulo(padroes[u]) || inicial));
      }
      return lista;
    });

    var sel = 0;
    barras.forEach(function (b, i) { if (b.padrao) sel = i; });

    // estado anterior (prévia do painel): mantém barra e variantes escolhidas
    if (cfg.estado && cfg.estado.escolhas) {
      if (cfg.estado.sel != null && cfg.estado.sel < barras.length) sel = cfg.estado.sel;
      cfg.estado.escolhas.forEach(function (ids, i) {
        if (!escolhas[i] || !ids) return;
        for (var u = 0; u < escolhas[i].length && u < ids.length; u++) {
          if (porId[String(ids[u])]) escolhas[i][u] = porId[String(ids[u])];
        }
      });
      (cfg.estado.presentes || []).forEach(function (id, k) {
        if (!presentes[k] || !id) return;
        var pp = brindePorProduto[numeroId(presentes[k].produto.id)];
        pp.variants.forEach(function (v) { if (String(v.id) === String(id)) escolhasPresente[k] = v; });
      });
      (cfg.estado.brindes || []).forEach(function (ids, i) {
        if (!escolhasBrinde[i] || !ids) return;
        var validos = brindesDaBarra(barras[i]).map(function (p) { return String(p.id); });
        for (var u = 0; u < escolhasBrinde[i].length && u < ids.length; u++) {
          var achado = varianteBrinde(ids[u]);
          if (achado && validos.indexOf(String(achado.produto.id)) >= 0) escolhasBrinde[i][u] = achado.variante;
        }
      });
    }
    if (barras[sel] && barras[sel].esgotada) {
      for (var i0 = 0; i0 < barras.length; i0++) if (!barras[i0].esgotada) { sel = i0; break; }
    }

    var idUnico = 'vtb' + Math.random().toString(36).slice(2, 8);

    /* ---------- desenho ---------- */

    function varsBarra(b, i) {
      var r = calcular(b, escolhas[i], opcoes, escolhasBrinde[i]);
      var pct = r.cheio > 0 ? Math.round(r.economia * 100 / r.cheio) : 0;
      return {
        r: r,
        vars: {
          price: formatar(r.final),
          compare_price: formatar(r.cheio),
          saved: formatar(r.economia),
          saved_percent: pct + '%',
          quantity: String(r.unidades),
          unit_price: formatar(Math.round(r.final / Math.max(1, r.unidades)))
        }
      };
    }

    function htmlSeletor(i, u) {
      var v = escolhas[i][u];
      var ops = produto.options || [];
      if (!ops.length || (ops.length === 1 && produto.variants.length === 1)) return '';
      var h = '<div class="vtb__selects">';
      ops.forEach(function (op, oi) {
        var atual = v ? v.options[oi] : '';
        h += '<select class="vtb__select" data-barra="' + i + '" data-unidade="' + u + '" data-opcao="' + oi + '" aria-label="' + esc(op.name) + '">';
        (op.values || []).forEach(function (val) {
          // disponibilidade considerando as outras opções já escolhidas
          var alvo = v ? v.options.slice() : [];
          alvo[oi] = val;
          var cand = achar(alvo);
          var indisponivel = !cand || !cand.available;
          if (indisponivel && opcoes.ocultarIndisponiveis && val !== atual) return;
          h += '<option value="' + esc(val) + '"' + (val === atual ? ' selected' : '') + (indisponivel ? ' data-indisponivel' : '') + '>' +
            esc(val) + (indisponivel ? ' — ' + esc(texto(bundle.textos && bundle.textos.esgotado, locale) || 'Sold out') : '') + '</option>';
        });
        h += '</select>';
      });
      return h + '</div>';
    }

    function achar(valores) {
      for (var i = 0; i < produto.variants.length; i++) {
        var v = produto.variants[i];
        var ok = true;
        for (var j = 0; j < valores.length; j++) if (v.options[j] !== valores[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function htmlSeletorBrinde(i, u) {
      var b = barras[i];
      var v = escolhasBrinde[i][u];
      var atual = varianteBrinde(v && v.id);
      var p = atual ? atual.produto : brindesDaBarra(b)[0];
      var opcoesBrinde = brindesDaBarra(b);
      var h = '<div class="vtb__selects">';
      if (opcoesBrinde.length > 1) {
        h += '<select class="vtb__select" data-alvo="brinde-produto" data-barra="' + i + '" data-unidade="' + u + '" aria-label="Product">';
        opcoesBrinde.forEach(function (op) {
          h += '<option value="' + op.id + '"' + (String(op.id) === String(p.id) ? ' selected' : '') + '>' + esc(op.title) + '</option>';
        });
        h += '</select>';
      }
      if (p.variants.length > 1) {
        (p.options || []).forEach(function (op, oi) {
          var valorAtual = v ? v.options[oi] : '';
          h += '<select class="vtb__select" data-alvo="brinde" data-barra="' + i + '" data-unidade="' + u + '" data-opcao="' + oi + '" aria-label="' + esc(op.name) + '">';
          (op.values || []).forEach(function (val) {
            var alvo = v ? v.options.slice() : [];
            alvo[oi] = val;
            var cand = acharEm(p, alvo);
            var indisponivel = !cand || !cand.available;
            if (indisponivel && opcoes.ocultarIndisponiveis && val !== valorAtual) return;
            h += '<option value="' + esc(val) + '"' + (val === valorAtual ? ' selected' : '') + '>' +
              esc(val) + (indisponivel ? ' — ' + esc(texto(bundle.textos && bundle.textos.esgotado, locale) || 'Sold out') : '') + '</option>';
          });
          h += '</select>';
        });
      }
      return h === '<div class="vtb__selects">' ? '' : h + '</div>';
    }

    function htmlBrindes(i) {
      var b = barras[i];
      var pct = b.descontoGanhe == null ? 100 : Number(b.descontoGanhe);
      var h = '';
      escolhasBrinde[i].forEach(function (v, u) {
        var achado = varianteBrinde(v && v.id);
        var p = achado ? achado.produto : brindesDaBarra(b)[0];
        var rotulo = preencher(texto(b.rotuloBrinde, locale), { n: String(u + 1) });
        var img = (v && v.image) || p.image;
        var cheio = v ? (opcoes.usarComparativo && v.compare_at_price > v.price ? v.compare_at_price : v.price) : 0;
        var final = v ? v.price - Math.round(v.price * pct / 100) : 0;
        var gratisTxt = texto(bundle.textos && bundle.textos.gratis, locale) || 'FREE';
        h += '<div class="vtb__item vtb__item--brinde">' +
          (img ? '<img class="vtb__item-img" src="' + esc(img) + '" alt="" loading="lazy" width="80" height="80">' : '') +
          '<div class="vtb__item-corpo">' +
          (rotulo ? '<div class="vtb__rotulo">' + esc(rotulo) + '</div>' : '') +
          '<div class="vtb__brinde-info"><span class="vtb__brinde-nome">' + esc(p.title) + '</span>' +
          '<span class="vtb__brinde-preco">' + (cheio > final ? '<s>' + esc(formatar(cheio)) + '</s> ' : '') +
          '<b>' + esc(final <= 0 ? gratisTxt : formatar(final)) + '</b></span></div>' +
          htmlSeletorBrinde(i, u) +
          '</div></div>';
      });
      return h;
    }

    function htmlPresentes() {
      var h = '';
      presentes.forEach(function (g, k) {
        if (!presenteVale(g, barras[sel])) return;
        var p = brindePorProduto[numeroId(g.produto.id)];
        var v = escolhasPresente[k];
        var valor = v ? Math.max(v.compare_at_price || 0, v.price || 0) : 0;
        var qtd = Math.max(1, g.quantidade | 0);
        var nome = preencher(texto(g.nome, locale) || '{{title}}', { title: p.title, value: formatar(valor * qtd) });
        var tag = preencher(texto(g.tag, locale), { title: p.title, value: formatar(valor * qtd) });
        var gratisTxt = texto(bundle.textos && bundle.textos.gratis, locale) || 'FREE';
        var img = (v && v.image) || p.image;
        var seletores = '';
        if (p.variants.length > 1) {
          seletores = '<div class="vtb__selects">';
          (p.options || []).forEach(function (op, oi) {
            var atual = v ? v.options[oi] : '';
            seletores += '<select class="vtb__select" data-alvo="presente" data-presente="' + k + '" data-opcao="' + oi + '" aria-label="' + esc(op.name) + '">';
            (op.values || []).forEach(function (val) {
              var alvo = v ? v.options.slice() : [];
              alvo[oi] = val;
              var cand = acharEm(p, alvo);
              if ((!cand || !cand.available) && opcoes.ocultarIndisponiveis && val !== atual) return;
              seletores += '<option value="' + esc(val) + '"' + (val === atual ? ' selected' : '') + '>' + esc(val) + '</option>';
            });
            seletores += '</select>';
          });
          seletores += '</div>';
        }
        h += '<div class="vtb__presente">' +
          (img ? '<img class="vtb__presente-img" src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') +
          '<div class="vtb__presente-corpo">' +
          '<div class="vtb__presente-topo">' + (tag ? '<span class="vtb__presente-tag">' + esc(tag) + '</span>' : '') +
          (g.mostrarValor !== false ? '<span class="vtb__presente-valor">' + (valor > 0 ? '<s>' + esc(formatar(valor * qtd)) + '</s> ' : '') + '<b>' + esc(gratisTxt) + '</b></span>' : '') +
          '</div>' +
          '<div class="vtb__presente-nome">' + (qtd > 1 ? qtd + '× ' : '') + esc(nome) + '</div>' +
          seletores +
          '</div></div>';
      });
      return h ? '<div class="vtb__presentes">' + h + '</div>' : '';
    }

    function htmlItens(i) {
      var b = barras[i];
      var mix = ehMix(b);
      var n = unidadesPrincipais(b);
      var mostrarPrincipais = produto.variants.length > 1 && !opcoes.ocultarSeletores &&
        !(n === 1 && opcoes.mostrarUnico === false);
      var h = '';
      if (mostrarPrincipais) h += htmlPrincipais(i, b, n, mix);
      if (mix) h += htmlBrindes(i);
      return h ? '<div class="vtb__itens">' + h + '</div>' : '';
    }

    function htmlPrincipais(i, b, n, mix) {
      var porItem = opcoes.variantesPorItem !== false;
      var qtd = porItem ? n : 1;
      var h = '';
      for (var u = 0; u < qtd; u++) {
        var v = escolhas[i][u];
        var gratis = !mix && porItem && u >= (b.compre | 0);
        var modelo = gratis ? texto(b.rotuloGratis, locale) : texto(b.rotuloItem, locale);
        var numero = gratis ? u - (b.compre | 0) + 1 : u + 1;
        var rotulo = preencher(modelo, { n: String(numero) });
        var img = (v && v.image) || produto.image;
        h += '<div class="vtb__item' + (gratis ? ' vtb__item--gratis' : '') + '">' +
          (img ? '<img class="vtb__item-img" src="' + esc(img) + '" alt="" loading="lazy" width="80" height="80">' : '') +
          '<div class="vtb__item-corpo">' +
          (rotulo ? '<div class="vtb__rotulo">' + esc(rotulo) + '</div>' : '') +
          htmlSeletor(i, u) +
          '</div></div>';
      }
      return h;
    }

    function acharEm(p, valores) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        var ok = true;
        for (var j = 0; j < valores.length; j++) if (v.options[j] !== valores[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function desenhar() {
      var layout = estilo.layout || 'empilhado';
      var itensDentro = layout === 'empilhado' || layout === 'lista';
      var titulo = texto(bundle.textos && bundle.textos.tituloBloco, locale);
      var h = '<div class="vtb vtb--' + esc(layout) + '" id="' + idUnico + '" style="' + variaveisCss(estilo) + '">';
      if (titulo) h += '<div class="vtb__titulo-bloco"><span>' + esc(titulo) + '</span></div>';
      h += '<div class="vtb__barras" role="radiogroup">';
      barras.forEach(function (b, i) {
        var d = varsBarra(b, i);
        var ativa = i === sel;
        var t = preencher(texto(b.titulo, locale), d.vars);
        var st = preencher(texto(b.subtitulo, locale), d.vars);
        var et = preencher(texto(b.etiqueta, locale), d.vars);
        var selo = preencher(texto(b.selo, locale), d.vars);
        var mostraCheio = d.r.cheio > d.r.final;
        h += '<div class="vtb__barra' + (ativa ? ' is-sel' : '') + (b.esgotada ? ' is-esgotada' : '') + (selo ? ' tem-selo' : '') +
          '" role="radio" tabindex="' + (ativa ? '0' : '-1') + '" aria-checked="' + ativa + '" data-barra="' + i + '">';
        if (selo) h += '<span class="vtb__selo">' + esc(selo) + '</span>';
        h += '<div class="vtb__linha">' +
          '<span class="vtb__radio" aria-hidden="true"></span>' +
          '<div class="vtb__textos">' +
          '<div class="vtb__titulo">' + esc(t) + (et ? ' <span class="vtb__etiqueta">' + esc(et) + '</span>' : '') + '</div>' +
          (st ? '<div class="vtb__sub">' + esc(st) + '</div>' : '') +
          '</div>' +
          '<div class="vtb__precos">' +
          '<div class="vtb__preco">' + esc(opcoes.precoPorItem ? d.vars.unit_price : d.vars.price) + '</div>' +
          (mostraCheio ? '<div class="vtb__cheio">' + esc(opcoes.precoPorItem ? formatar(Math.round(d.r.cheio / Math.max(1, d.r.unidades))) : d.vars.compare_price) + '</div>' : '') +
          '</div></div>';
        if (b.esgotada) h += '<div class="vtb__esgotada">' + esc(texto(bundle.textos && bundle.textos.esgotado, locale) || 'Sold out') + '</div>';
        if (ativa && itensDentro) h += htmlItens(i);
        h += '</div>';
      });
      h += '</div>';
      if (!itensDentro) h += htmlItens(sel);
      h += htmlPresentes();
      h += '</div>';
      if (estilo.css) h += '<style>' + String(estilo.css).replace(/<\/style/gi, '') + '</style>';
      raiz.innerHTML = h;
      sincronizarFormulario();
    }

    /* ---------- interação ---------- */

    function escolherBarra(i) {
      if (i === sel || !barras[i] || barras[i].esgotada) return;
      sel = i;
      enviar('s', { r: barras[i].id });
      desenhar();
      var el = raiz.querySelector('.vtb__barra[data-barra="' + i + '"]');
      if (el && !cfg.previa) el.focus({ preventScroll: true });
      avisar();
    }

    raiz.addEventListener('click', function (ev) {
      if (ev.target.closest('select')) return;
      var b = ev.target.closest('.vtb__barra');
      if (b) escolherBarra(Number(b.getAttribute('data-barra')));
    });

    raiz.addEventListener('keydown', function (ev) {
      var b = ev.target.closest && ev.target.closest('.vtb__barra');
      if (!b) return;
      var i = Number(b.getAttribute('data-barra'));
      if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') { ev.preventDefault(); escolherBarra(Math.min(barras.length - 1, i + 1)); }
      if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') { ev.preventDefault(); escolherBarra(Math.max(0, i - 1)); }
      if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); escolherBarra(i); }
    });

    raiz.addEventListener('change', function (ev) {
      var s = ev.target.closest('.vtb__select');
      if (!s) return;
      var i = Number(s.getAttribute('data-barra'));
      var u = Number(s.getAttribute('data-unidade'));
      var oi = Number(s.getAttribute('data-opcao'));
      var alvoSel = s.getAttribute('data-alvo');
      if (alvoSel === 'presente') {
        var kp = Number(s.getAttribute('data-presente'));
        var gp = presentes[kp];
        var pp = gp && brindePorProduto[numeroId(gp.produto.id)];
        if (!pp) return;
        var valsP = (escolhasPresente[kp] || primeiraDisponivel(pp)).options.slice();
        valsP[oi] = s.value;
        var nvp = acharEm(pp, valsP);
        if (!nvp) for (var kq = 0; kq < pp.variants.length; kq++) if (pp.variants[kq].options[oi] === s.value) { nvp = pp.variants[kq]; break; }
        if (!nvp) return;
        escolhasPresente[kp] = nvp;
        desenhar();
        var focoP = raiz.querySelector('.vtb__select[data-alvo="presente"][data-presente="' + kp + '"][data-opcao="' + oi + '"]');
        if (focoP && !cfg.previa) focoP.focus({ preventScroll: true });
        avisar();
        return;
      }
      if (alvoSel === 'brinde-produto' || alvoSel === 'brinde') {
        var nv = null;
        if (alvoSel === 'brinde-produto') {
          var pb = brindePorProduto[String(s.value)];
          if (pb) nv = primeiraDisponivel(pb);
        } else {
          var atualB = varianteBrinde(escolhasBrinde[i][u] && escolhasBrinde[i][u].id);
          if (atualB) {
            var vals = atualB.variante.options.slice();
            vals[oi] = s.value;
            nv = acharEm(atualB.produto, vals);
            if (!nv) for (var kb = 0; kb < atualB.produto.variants.length; kb++) {
              if (atualB.produto.variants[kb].options[oi] === s.value) { nv = atualB.produto.variants[kb]; break; }
            }
          }
        }
        if (!nv) return;
        escolhasBrinde[i][u] = nv;
        desenhar();
        var focoB = raiz.querySelector('.vtb__select[data-alvo="' + alvoSel + '"][data-barra="' + i + '"][data-unidade="' + u + '"]' + (alvoSel === 'brinde' ? '[data-opcao="' + oi + '"]' : ''));
        if (focoB && !cfg.previa) focoB.focus({ preventScroll: true });
        avisar();
        return;
      }
      var atual = escolhas[i][u] || inicial;
      var alvo = atual.options.slice();
      alvo[oi] = s.value;
      var v = achar(alvo);
      if (!v) {
        // combinação que não existe: pega a primeira variante com esse valor
        for (var k = 0; k < produto.variants.length; k++) {
          if (produto.variants[k].options[oi] === s.value) { v = produto.variants[k]; break; }
        }
      }
      if (!v) return;
      if (opcoes.variantesPorItem === false) {
        for (var x = 0; x < escolhas[i].length; x++) escolhas[i][x] = v;
      } else {
        escolhas[i][u] = v;
      }
      desenhar();
      var novo = raiz.querySelector('.vtb__select[data-barra="' + i + '"][data-unidade="' + u + '"][data-opcao="' + oi + '"]');
      if (novo && !cfg.previa) novo.focus({ preventScroll: true });
      mostrarNaGaleria(v);
      avisar();
    });

    /*
     * Cor escolhida no bundle aparece nas fotos principais, como um clique no
     * seletor nativo: usa o selectVariant do <variant-picker> do Impact.
     * A trava impede que o tema devolva essa troca para o item 1 do bundle.
     */
    var ignorarTema = false;
    function mostrarNaGaleria(v) {
      if (!form || !v || opcoes.atualizarGaleria === false) return;
      var picker = document.querySelector('variant-picker[form="' + form.getAttribute('id') + '"]');
      if (!picker || typeof picker.selectVariant !== 'function') return;
      ignorarTema = true;
      try { picker.selectVariant(v.id); } catch (e) { /* galeria é enfeite: nunca trava o bundle */ }
      ignorarTema = false;
      // o tema reescreve o botão ao trocar variante
      setTimeout(atualizarBotaoDeNovo, 0);
    }

    function avisar() {
      if (typeof cfg.aoMudar === 'function') cfg.aoMudar(itensSelecionados());
    }

    function itensSelecionados() {
      var b = barras[sel];
      var mapa = {};
      var ordem = [];
      escolhas[sel].concat(escolhasBrinde[sel] || []).forEach(function (v) {
        if (!v) return;
        var k = String(v.id);
        if (!mapa[k]) { mapa[k] = 0; ordem.push(k); }
        mapa[k]++;
      });
      var itens = ordem.map(function (k) {
        return { id: Number(k), quantidade: mapa[k], propriedade: bundle.id + ':' + b.id };
      });
      presentes.forEach(function (g, k) {
        var v = escolhasPresente[k];
        if (!v || !presenteVale(g, b)) return;
        itens.push({ id: Number(v.id), quantidade: Math.max(1, g.quantidade | 0), presente: bundle.id + ':' + g.id });
      });
      return itens;
    }

    /* ---------- eventos para o dashboard ---------- */

    function visitante() {
      var chave = 'vtb_vid';
      try {
        var v = localStorage.getItem(chave);
        if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(chave, v); }
        return v;
      } catch (e) {
        window.__vtbVid = window.__vtbVid || Math.random().toString(36).slice(2);
        return window.__vtbVid;
      }
    }

    function enviar(tipo, extra) {
      if (!cfg.coletor || cfg.previa) return;
      try {
        var corpo = { t: tipo, b: bundle.id, p: produto.id, vid: visitante(), pais: cfg.pais || '', l: locale,
          m: window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 1 : 0, cur: cfg.moeda || '' };
        for (var k in extra) corpo[k] = extra[k];
        var dados = JSON.stringify(corpo);
        var url = String(cfg.coletor).replace(/\/+$/, '') + '/api/e';
        if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([dados], { type: 'text/plain' }))) return;
        fetch(url, { method: 'POST', body: dados, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } });
      } catch (e) { /* métrica nunca atrapalha a compra */ }
    }

    /* ---------- integração com o formulário do tema ---------- */

    var form = cfg.form || null;
    var caixaInputs = null;

    function sincronizarFormulario() {
      if (!form) return;
      if (!caixaInputs || !raiz.contains(caixaInputs)) {
        caixaInputs = document.createElement('div');
        caixaInputs.hidden = true;
        caixaInputs.className = 'vtb__inputs';
        raiz.appendChild(caixaInputs);
      }
      var formId = form.getAttribute('id');
      var itens = itensSelecionados();
      var h = '';
      itens.forEach(function (it, k) {
        h += '<input type="hidden" form="' + esc(formId) + '" name="items[' + k + '][id]" value="' + it.id + '">' +
          '<input type="hidden" form="' + esc(formId) + '" name="items[' + k + '][quantity]" value="' + it.quantidade + '">' +
          (it.presente ?
            '<input type="hidden" form="' + esc(formId) + '" name="items[' + k + '][properties][_vt_presente]" value="' + esc(it.presente) + '">' :
            '<input type="hidden" form="' + esc(formId) + '" name="items[' + k + '][properties][' + PROPRIEDADE + ']" value="' + esc(it.propriedade) + '">');
      });
      caixaInputs.innerHTML = h;
      // Com items[] no POST o carrinho ignora o id; desativado ele nem vai.
      // O tema ainda lê form.id.value para montar a url das seções — continua funcionando.
      var campoId = form.querySelector('input[name="id"]');
      if (campoId) campoId.disabled = true;
      atualizarBotao();
    }

    function atualizarBotaoDeNovo() {
      if (!form) return;
      var botao = form.querySelector('button[type="submit"]');
      var alvo = botao && (botao.getAttribute('is') === 'custom-button' && botao.firstElementChild ? botao.firstElementChild : botao);
      if (alvo) alvo.removeAttribute('data-vtb-base');
      atualizarBotao();
    }

    function atualizarBotao() {
      if (!form || !opcoes.precoNoBotao) return;
      var botao = form.querySelector('button[type="submit"]');
      if (!botao || botao.disabled) return;
      var alvo = botao.getAttribute('is') === 'custom-button' && botao.firstElementChild ? botao.firstElementChild : botao;
      var d = varsBarra(barras[sel], sel);
      var base = alvo.getAttribute('data-vtb-base');
      if (!base) {
        base = alvo.textContent.replace(/\s+·\s+.*$/, '').trim();
        alvo.setAttribute('data-vtb-base', base);
      }
      alvo.textContent = base + ' · ' + d.vars.price;
    }

    if (form) {
      // Variante escolhida no seletor do tema vira a primeira unidade de cada barra
      form.addEventListener('variant:change', function (ev) {
        var v = ev.detail && ev.detail.variant;
        if (ignorarTema || !v || opcoes.sincronizarTema === false) return;
        var nova = porId[String(v.id)];
        if (!nova) return;
        inicial = nova;
        escolhas.forEach(function (lista) {
          if (opcoes.variantesPorItem === false) { for (var x = 0; x < lista.length; x++) lista[x] = nova; }
          else lista[0] = nova;
        });
        desenhar();
        // o tema reescreve o texto do botão depois deste evento
        setTimeout(atualizarBotaoDeNovo, 0);
      });

      if (opcoes.irCheckout) {
        form.addEventListener('variant:add', function () {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
        });
      }

      // Garantia: se algo apagou os inputs, remonta antes do envio.
      document.addEventListener('submit', function (ev) {
        if (ev.target !== form) return;
        sincronizarFormulario();
        var d = varsBarra(barras[sel], sel);
        enviar('a', { r: barras[sel].id, q: d.r.unidades, v: d.r.final });
      }, true);

      // visto: 1x por carregamento, quando pelo menos metade do bloco aparece na tela
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entradas) {
          if (entradas.some(function (e) { return e.isIntersecting; })) {
            obs.disconnect();
            enviar('v', { r: barras[sel].id });
          }
        }, { threshold: 0.5 });
        obs.observe(raiz);
      } else {
        enviar('v', { r: barras[sel].id });
      }
    }

    desenhar();

    return {
      itens: itensSelecionados,
      barraSelecionada: function () { return sel; },
      estado: function () {
        var ids = function (l) { return l.map(function (v) { return v ? v.id : null; }); };
        return { sel: sel, escolhas: escolhas.map(ids), brindes: escolhasBrinde.map(ids), presentes: ids(escolhasPresente) };
      },
      redesenhar: desenhar
    };
  }

  window.VTBundle = {
    montar: montar,
    calcular: calcular,
    formatadorPorAmostra: formatadorPorAmostra,
    ESTILO_PADRAO: ESTILO_PADRAO,
    texto: texto
  };

  /* --------------------------------------------------------- loja: auto */

  function iniciarNaLoja(host) {
    if (host.__vtb) return;
    host.__vtb = true;
    try {
      var ler = function (tipo) {
        var s = host.querySelector('script[data-vtb="' + tipo + '"]');
        return s ? JSON.parse(s.textContent) : null;
      };
      var bundle = ler('bundle'), produto = ler('produto'), ctx = ler('ctx') || {}, brindes = ler('brindes') || [];
      if (!bundle || !produto) return;
      var form = document.getElementById(host.getAttribute('data-form'));
      var caixa = document.createElement('div');
      caixa.className = 'vtb-raiz';
      host.appendChild(caixa);
      var ok = montar(caixa, {
        bundle: bundle,
        produto: produto,
        brindes: brindes,
        locale: ctx.locale,
        dinheiro: ctx.dinheiro,
        varianteInicial: ctx.variante,
        coletor: ctx.coletor,
        pais: ctx.pais,
        moeda: ctx.moeda,
        form: form
      });
      if (ok) host.classList.add('is-pronto');
    } catch (e) {
      // Falhou: devolve o formulário ao normal para a compra nunca travar.
      var f = document.getElementById(host.getAttribute('data-form'));
      var campo = f && f.querySelector('input[name="id"]');
      if (campo) campo.disabled = false;
      host.innerHTML = '';
      if (window.console) console.error('[vt-bundle]', e);
    }
  }

  function varrer() {
    var hosts = document.querySelectorAll('vt-bundle[data-form]');
    for (var i = 0; i < hosts.length; i++) iniciarNaLoja(hosts[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();
  // seções recarregadas pelo editor de tema ou quick view
  document.addEventListener('shopify:section:load', varrer);
})();
